@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  container-type: inline-size;
  container-name: host-container;
  block-size: 100%;
  inline-size: 100%;
  align-items: center;
  justify-content: center;
}

.slide {
  display: grid;
  grid-template-columns: 1fr 1fr;
  block-size: 100%;
  border-radius: var(--border-radius-m);
  max-block-size: 700px;
  max-inline-size: 1100px;
  background-color: var(--color-accent-surface-elevation-1);
  overflow: hidden;

  &__illustration {
    overflow: hidden;
    object-fit: cover;
    object-position: left;
    block-size: 100%;
    inline-size: 100%;
  }

  &__main {
    display: grid;
    block-size: 100%;
    inline-size: 100%;
    padding: 48px;
    transform: translateY(4px);
    transition: var(--display-items-transtion-time) all;
    opacity: 0;

    position: relative;

    &--visible {
      transform: translateY(0);
      opacity: 1;
    }
  }

  &__main-container {
    display: grid;
    place-self: center;
    gap: var(--spacing-gap-xxl);
    inline-size: 100%;
    max-inline-size: 480px;
  }

  &__main-header {
    display: grid;
    gap: var(--spacing-gap-xxl);
  }

  &__main-title {
    display: flex;
    flex-direction: column;
    font-size: var(--font-size-header-h2);
    font-weight: var(--font-style-semi-bold);
    letter-spacing: 0.02em;
    line-height: var(--line-height-tight);
    color: var(--color-text-neutral-strawberry);
  }

  &__main-description {
    display: grid;
    gap: 40px;
    font-size: var(--font-size-body-l);
    font-weight: var(--font-style-regular);
    line-height: var(--line-height-spacious);
    color: var(--color-text-neutral-disabled);
  }
}

.terms-conditions {
  text-decoration: underline;
}

.items-list {
  inline-size: 100%;
  --ch-combo-box__popover-max-inline-size: 100%;
}

.buttons-container {
  display: flex;
  inline-size: 100%;
  gap: var(--spacing-gap-xl);
}

.continue-btn,
.cancel-btn {
  flex: 1;
}

@container host-container (max-width: 768px) {
  .slide {
    grid-template-columns: 1fr 2fr;
  }
}

@container host-container (max-width: 640px) {
  .slide {
    grid-template-columns: 1fr 5fr;
  }
}
